// extracted by mini-css-extract-plugin
export default {"componentWrapper":"SearchInput_componentWrapper__pCE2Q","form":"SearchInput_form__9K0dX","searchButton":"SearchInput_searchButton__fA5oN","input":"SearchInput_input__Z7dn9"};